export const FILTER_OPTIONS = [
	{
		id: 4,
		value: 'stt',
		name: 'STT',
	},
	{
		id: 2,
		value: 'hoTen',
		name: 'Họ tên',
	},
	{
		id: 3,
		value: 'tuoi',
		name: 'Tuổi',
	},
	{
		id: 1,
		value: 'maBenhNhan',
		name: 'Mã BN',
	},
];

export const INSURANCE_STATUS = {
	APPROVE: 'ins_visit_approved',
	UNAPPROVE: 'ins_visit_unapproved',
};

export const VIEW_TYPE_CONFIG = {
	PATIENT_CHECK_IN: 'CHECK_IN',
	PATIENT_APPROVE: 'INSURANCE_APPROVE',
};